var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShieldStar = function SvgIconShieldStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 8.625a1 1 0 1 0-2 0v2.372l-2.252-.735a1 1 0 0 0-.62 1.901l2.256.736-1.397 1.926A1 1 0 1 0 10.607 16L12 14.078 13.394 16a1 1 0 1 0 1.619-1.175L13.616 12.9l2.257-.737a1 1 0 0 0-.62-1.901L13 10.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3.5a1.75 1.75 0 0 0-1.75 1.75v5.503c0 8.562 7.27 11.395 8.688 11.867.364.13.76.13 1.124 0 1.418-.472 8.688-3.305 8.688-11.867V5.25A1.75 1.75 0 0 0 19.5 3.5zm.25 7.253V5.5h14.5v5.253c0 7.022-5.82 9.455-7.25 9.946-1.43-.49-7.25-2.924-7.25-9.946",
    clipRule: "evenodd"
  }))));
};
export default SvgIconShieldStar;